import React from "react";
import { Link } from "react-router-dom";
import "./commonBanner.scss";
import { homeURL } from "../../helpers/constants";
import { commonBanner, commonBannerMob, homeIcon } from "../../source";
import { useWindowSize } from "react-use";

const CommonBanner = ({
  banner,
  title,
  description,
  link1,
  link2,
  linkText1,
  linkText2,
}) => {
  const { width } = useWindowSize();

  return (
    <>
      <div
        className="com_banner_container"
        data-aos="fade"
        style={{ height: "8em"}}
      >
        {/* <img
          width={1920}
          height={520}
          src={banner ? banner : width > 767 ? commonBanner : commonBannerMob}
          alt="banner"
          className="banner"
        /> */}
        <div className="my_container">
          <div className="breadcrumb">
            <div className="link_wrapper">
              <Link to={homeURL} className={`link`}>
                <img src={homeIcon} alt="home" className="home_icon" />
              </Link>
              <Link to={homeURL} className={`link`}>
                &nbsp;<span>| Home</span>
              </Link>
              <Link
                to={link1}
                className={`link space ${!linkText2 ? "disabled" : ""}`}
              >
                {" | " + linkText1}
              </Link>
              {linkText2 && (
                <Link to={link2} className={`link disabled`}>
                  {" | " + linkText2}
                </Link>
              )}
            </div>
          </div>
          {/* <div className="content_wrapper">
            {title && (
              <h1
                className="banner_heading"
                dangerouslySetInnerHTML={{ __html: title }}
              ></h1>
            )}
            {description && (
              <p
                className="banner_description"
                dangerouslySetInnerHTML={{ __html: description }}
              ></p>
            )}
          </div> */}
        </div>
      </div>
    </>
  );
};

export default CommonBanner;
